/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconLetterOSmall = createReactComponent("outline", "letter-o-small", "IconLetterOSmall", [["path", { "d": "M12 8a2 2 0 0 1 2 2v4a2 2 0 1 1 -4 0v-4a2 2 0 0 1 2 -2z", "key": "svg-0" }]]);

export { IconLetterOSmall as default };
//# sourceMappingURL=IconLetterOSmall.mjs.map
